import { ReactComponent as BackIcon } from "../../assets/icons/arrow-left.svg";
import background from "../../assets/images/background.png";
import { useState } from "react";
import { auth } from "../../services/firebase";

const ForgetPassword = ({history}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    function handleSubmit(e){
        e.preventDefault();
        setIsLoading(true);
        auth.sendPasswordResetEmail(email).then((res)=>{
            setSuccess(true);
            setIsLoading(false);
        }).catch((e)=>{
            if(e.code === "auth/invalid-email") {
                setError("Invalid Email Address");
            }
            setIsLoading(false);
        });
    }

    return (
        <div
            id="login-page"
            style={{
                backgroundImage: `url(${background})`,
                minHeight: "100vh",
            }}
        >
            <div className="container pb-5">
                <div className="btn mt-3">
                    <BackIcon
                        width="32"
                        onClick={() => {
                            history.goBack();
                        }}
                    />
                </div>
                <h1 className="text-center text-light my-5">Forgot Password</h1>
                <div className="container-fluid">
                    {error !== "" && (
                        <div style={{ maxWidth: "32rem" }} className="alert alert-danger mx-auto my-4" role="alert">
                            {error}
                        </div>
                    )}
                    {success && (
                        <div style={{ maxWidth: "32rem" }} className="alert alert-success mx-auto my-4" role="alert">
                            Password reset link has been sent to your email successfully!
                        </div>
                    )}
                    <form
                        className="mx-auto"
                        style={{ maxWidth: "32rem" }}
                        onSubmit={handleSubmit}
                    >
                        <input
                            onChange={(e) => setEmail(e.target.value)}
                            style={{height : "3rem"}}
                            type="text"
                            placeholder="Email *"
                            className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom mb-4 h5"
                            required
                        />
                        <div className="d-flex justify-content-center">
                            {isLoading ? (
                                <button
                                    style={{ height: "3rem" }}
                                    className="d-flex align-items-center btn btn-outline-light rounded-pill px-5 text-btn"
                                disabled>
                                    Sending Reset Link...
                                    <div className="spinner-border ms-4" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </button>
                            ) : (
                                <button
                                    style={{ height: "3rem" }}
                                    className=" btn btn-outline-light rounded-pill px-5 text-btn"
                                >
                                    Send Password Reset Link
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
 
export default ForgetPassword;